import React from "react";
import {
  Typography,
  Card,
  CardActionArea,
  CardHeader,
  CardContent,
  CardMedia
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import {} from "@material-ui/core/colors";

const useStyles = makeStyles({
  card: {
    maxWidth: 500,
    float: "right"
  },
  media: {
    height: 400 // necessory for card image
  },
  cardHeader: {
    backgroundColor: "#3F51B5",
    color: "#FFFFFF"
  }
});

export const SignsAndSymptons = () => {
  const classes = useStyles();
  return (
    <div>
      <Typography variant="h3">Signs of stroke</Typography>
      <Typography variant="body1">
        Sudden numbness or weakness in the face, arm, or leg, especially on one side of the body
      </Typography>
      <ul>
        <li>
          Sudden <strong>confusion, talking difficulty</strong> or <strong>difficulty understanding speech</strong>
        </li>
        <li>
          Sudden <strong>numbness</strong> or <strong>weakness</strong> in the face, arm, or leg, especially on one side
          of the body
        </li>
        <li>
          Sudden onset <strong>severe headache</strong>
        </li>
        <li>
          Sudden <strong>trouble seeing</strong> in one or both eyes
        </li>
        <li>
          Sudden <strong>trouble walking</strong>, dizziness, loss of balance, or lack of coordination
        </li>
      </ul>
      <Typography variant="body1">Call 911 if anybody or you have the above symptoms</Typography>
      <Typography variant="body1">
        If your symptoms go away after a few minutes, you may have had a transient ischemic attack (tia).
      </Typography>
    </div>
  );
};
